
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/refund-policy-old",
      function () {
        return require("private-next-pages/legal/refund-policy-old.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/refund-policy-old"])
      });
    }
  